const initialState = {
    data: [], 
    header:[],
  
  };
  
  const COProfilereducers = (state = initialState, action: any) => {
    switch (action.type){
        case 'FETCH_GET_SUCCESS':
            return {... state,data:action.payload}; 
            case 'FETCH_HEADER_SUCCESS':
            return {... state,header:action.payload};                   
      default:
        return state;
    }
  };
  
  export default COProfilereducers;
  
  